import { TServerErrorResponse, User } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const USERS_ALL_GET = "users-all-get";
export const USER_GET = "user-get";
export const EXTERNAL_USER_GET = "external-user-get";
export const MY_USER_GET = "my-user-get";

export const getAllUsers = async () => {
  try {
    const response = await http.get<User[]>(links.user.index);

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getUser = async (userId?: string): Promise<User | undefined> => {
  if (!userId) return;
  try {
    const response = await http.get<User>(links.user.userById(userId));

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getUserByExternalId = async (
  externalUserId?: string,
): Promise<User | undefined> => {
  if (!externalUserId) return;
  try {
    const response = await http.get<User>(
      links.user.userByExternalId(externalUserId),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createUser = async (user: User) => {
  try {
    const response = await http.post<User>(links.user.index, user);

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateUser = async (user: Partial<User>) => {
  if (!user.id) return;

  try {
    const response = await http.patch<User>(links.user.userById(user.id), user);

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteUser = async (userId: string) => {
  try {
    const response = await http.delete<User>(links.user.userById(userId));

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const changePassword = async ({
  existingPassword,
  password,
}: {
  existingPassword: string;
  password: string;
}) => {
  try {
    const response = await http.put<User>(links.user.changePassword, {
      existingPassword,
      password,
    });

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
